import React, { useEffect, useMemo, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { FaUsers } from "react-icons/fa";
import "../../Pages/master_categories.css";
import {
  MdOutlineDashboard,
  MdSpaceDashboard,
  MdOutlineMovieCreation,
  MdMovie,
  MdAssignment,
  MdVerified,
  MdReceiptLong,
  MdPayments,
  MdOutlineReport,
  MdChat,
  MdInbox,
  MdForum,
  MdOutlinePhotoLibrary,
  MdCardGiftcard,
  MdCardMembership,
  MdCampaign,
  MdExpandMore,
  MdExpandLess,
} from "react-icons/md";

const NavItem = ({ to, end, icon: Icon, label }) => (
  <NavLink to={to} end={end} className="categorie-subtitle">
    <div className="child-title">
      <Icon size={22} className="childnav-icon" />
      <p className="childnav-name">{label}</p>
    </div>
  </NavLink>
);

const NavGroup = ({ label, icon: Icon, open, onToggle, children, active }) => (
  <div className={`nav-group${active ? " is-active" : ""}${open ? " is-open" : ""}`}>
    <button type="button" className="nav-group-toggle" onClick={onToggle}>
      <span className="child-title">
        <Icon size={22} className="childnav-icon" />
        <p className="childnav-name">{label}</p>
      </span>
      {open ? <MdExpandLess size={20} /> : <MdExpandMore size={20} />}
    </button>
    {open ? <div className="nav-group-children">{children}</div> : null}
  </div>
);

const MarketingNavbarComponent = () => {
  const location = useLocation();
  const permissions = JSON.parse(localStorage.getItem("permissions")) || [];
  const hasPermission = (perm) => permissions.includes(perm);

  const overviewPaths = useMemo(
    () => ["/dashboard/masters/invite-analytics"],
    []
  );
  const auditionPaths = useMemo(
    () => ["/dashboard/masters/Auditions", "/dashboard/masters/Audition-requirements"],
    []
  );
  const reportPaths = useMemo(
    () => ["/dashboard/masters/chat-reports", "/dashboard/masters/reports-inbox"],
    []
  );

  const pathname = location.pathname.toLowerCase();
  const overviewActive =
    pathname === "/dashboard" ||
    pathname === "/dashboard/" ||
    overviewPaths.some((path) => pathname.startsWith(path.toLowerCase()));
  const auditionActive = auditionPaths.some((path) =>
    pathname.startsWith(path.toLowerCase())
  );
  const reportActive = reportPaths.some((path) =>
    pathname.startsWith(path.toLowerCase())
  );

  const [overviewOpen, setOverviewOpen] = useState(overviewActive);
  const [auditionsOpen, setAuditionsOpen] = useState(auditionActive);
  const [reportsOpen, setReportsOpen] = useState(reportActive);

  useEffect(() => {
    if (overviewActive) setOverviewOpen(true);
  }, [overviewActive]);

  useEffect(() => {
    if (auditionActive) setAuditionsOpen(true);
  }, [auditionActive]);

  useEffect(() => {
    if (reportActive) setReportsOpen(true);
  }, [reportActive]);

  const showAuditions =
    hasPermission("accounts.view_audition") ||
    hasPermission("accounts.view_auditionrequirement");
  const showReports =
    hasPermission("accounts.view_message") || hasPermission("accounts.view_profile");

  return (
    <div className="categorie-header">
      <NavGroup
        label="Overview"
        icon={MdOutlineDashboard}
        open={overviewOpen}
        active={overviewActive}
        onToggle={() => setOverviewOpen((prev) => !prev)}
      >
        <NavItem to="/dashboard" end icon={MdSpaceDashboard} label="Dashboard" />
        {hasPermission("accounts.view_profile") && (
          <NavItem
            to="/dashboard/masters/invite-analytics"
            icon={MdCardGiftcard}
            label="Invite Analytics"
          />
        )}
      </NavGroup>

      {hasPermission("accounts.view_profile") && (
        <NavItem to="/dashboard/users" icon={FaUsers} label="Users" />
      )}

      {showAuditions && (
        <NavGroup
          label="Auditions"
          icon={MdOutlineMovieCreation}
          open={auditionsOpen}
          active={auditionActive}
          onToggle={() => setAuditionsOpen((prev) => !prev)}
        >
          {hasPermission("accounts.view_audition") && (
            <NavItem to="/dashboard/masters/Auditions" icon={MdMovie} label="All Auditions" />
          )}
          {hasPermission("accounts.view_auditionrequirement") && (
            <NavItem
              to="/dashboard/masters/Audition-requirements"
              icon={MdAssignment}
              label="Requirements"
            />
          )}
        </NavGroup>
      )}

      {hasPermission("accounts.view_verifiedprofile") && (
        <NavItem to="/dashboard/masters/verified" icon={MdVerified} label="Verified" />
      )}

      {hasPermission("accounts.view_order") && (
        <NavItem to="/dashboard/masters/orders" icon={MdReceiptLong} label="Orders" />
      )}

      {hasPermission("accounts.view_razorpaypayment") && (
        <NavItem to="/dashboard/masters/razor-pays" icon={MdPayments} label="Razor-pays" />
      )}

      {showReports && (
        <NavGroup
          label="Reports"
          icon={MdOutlineReport}
          open={reportsOpen}
          active={reportActive}
          onToggle={() => setReportsOpen((prev) => !prev)}
        >
          {hasPermission("accounts.view_message") && (
            <NavItem
              to="/dashboard/masters/chat-reports"
              icon={MdChat}
              label="Chat Reports"
            />
          )}
          {hasPermission("accounts.view_profile") && (
            <NavItem
              to="/dashboard/masters/reports-inbox"
              icon={MdInbox}
              label="Reports Inbox"
            />
          )}
        </NavGroup>
      )}

      {hasPermission("accounts.view_message") && (
        <NavItem to="/dashboard/masters/chat-table" icon={MdForum} label="Chat Table" />
      )}

      {hasPermission("accounts.view_profile") && (
        <NavItem
          to="/dashboard/masters/post-review"
          icon={MdOutlinePhotoLibrary}
          label="Post Review"
        />
      )}

      {hasPermission("accounts.view_order") && (
        <NavItem
          to="/dashboard/masters/casting-packages"
          icon={MdCardMembership}
          label="Casting Packages"
        />
      )}

      {(hasPermission("advertising.view_adcampaign") ||
        hasPermission("advertising.add_adcampaign") ||
        hasPermission("advertising.change_adcampaign")) && (
        <NavItem to="/dashboard/advertising/campaigns" icon={MdCampaign} label="Advertising" />
      )}
    </div>
  );
};

export { MarketingNavbarComponent };
